<template>
  <b-modal
    title="Create Program"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :visible="showModal"
    centered
    @hidden="reset">
    <b-form>

    <b-row>
      <h2 v-show="createProgramPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="createProgramPending" color="#489AAC" size="50px"></pulse-loader>
    </b-row>

    <b-form-group label="Program Type" label-class='addpersonlabel' label-for="title">
      <b-form-select size="lg"
        v-validate="'required'"
        data-vv-name="title"
        data-vv-as="title"
        :options="programTypesByState" id='title' v-model='title'
        :style="{ color: 'gray' }"
        >
        <template #first>
          <option disabled :value="null" >
            Select a program type...
          </option>
        </template>
      </b-form-select>
      <span v-show="inputValidationErrors.has('title')" class="text-info">{{ inputValidationErrors.first('title') }}</span>
    </b-form-group>

    <b-form-group v-if="title === 'Other'" label="Other Program Type" label-class='addpersonlabel' label-for="title_otherText">
      <b-form-input size="lg"
        v-validate="'required'"
        data-vv-name="title_otherText"
        data-vv-as="title_otherText"
        id='title_otherText' v-model='title_otherText'>
      </b-form-input>
      <span v-show="inputValidationErrors.has('title_otherText')" class="text-info">{{ inputValidationErrors.first('title_otherText') }}</span>
    </b-form-group>

    <b-alert
      :show="!uniqueProgramName"
      variant="warning"
      >
      <span>Please enter a unique program name.</span>
    </b-alert>

    <b-form-group v-if="isNewOrg">
      <b-form-checkbox
        v-model="isDefault">
        Set as default
      </b-form-checkbox>
    </b-form-group>

    </b-form>

    <b-alert
      fade
      :show="createProgramFailure || _.isObject(createProgramSuccess) || (isNewOrg && didSubmitNewProgram)"
      :variant="createProgramFailure ? 'danger' : 'success'">
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button type="button" variant="outline-primary" size="sm" class="float-right" @click="programHandler">
        <span class="button-text">Create</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'

  export default {
    name: 'create-program-modal',
    props: {
      organizationId: Number,
      orgPrograms: {
        type: Array,
        default: () => {
          return []
        }
      },
      showModal: Boolean,
      isNewOrg: {
        type: Boolean,
        default: () => {
          return false
        }
      },
      orgState: {
        type: String,
        default: ''
      }
    },
    data: function () {
      return {
        uniqueProgramName: true,
        title: null,
        newProgram: {},
        isDefault: false,
        didSubmitNewProgram: false
      }
    },
    watch: {
      createProgramSuccess: function (newValue) {
        if (this.showModal) {
          _.delay(this.clearForm, 1000)
          _.delay(this.reset, 1100)
        }
      }
    },
    computed: {
      // Create a computed property that looks at userContextOrganizationGroups and filters out Groups as a result of orgs that are not the records owningOrg
      // Do you have org admin rights for the owningOrg for this record
      ...mapGetters({
        createProgramPending: 'createProgramPending',
        createProgramSuccess: 'createProgramSuccess',
        createProgramFailure: 'createProgramFailure',
        newProgramDefault: 'getCreateProgram',
        programTypes: 'getProgramTypes',
        programTypesLA: 'getProgramTypesLA'
      }),
      programTypesByState () {
        if (this.orgState === 'LA') {
          return this.programTypesLA
        }
        return this.programTypes
      }
    },
    methods: {
      reset: function () {
        this.$emit('update:showModal', false)
        this.clearForm()
      },
      programHandler: function () {
        console.log('Unique Program Name - start ' + this.uniqueProgramName)
        this.uniqueProgramName = true
        console.log('Unique Program Name - reset ' + this.uniqueProgramName)
        let titleLC = this.title !== 'Other' ? this.title.toLowerCase() : this.title_otherText.toLowerCase()
        this.orgPrograms.forEach((program) => {
          if (program.title.toLowerCase() === titleLC ||
            (program.title === 'Other' &&
              program.title_otherText.toLowerCase() === titleLC)) {
            console.log(program.title.toLowerCase())
            console.log('Unique Program Name - Flag')
            this.uniqueProgramName = false
          }
        })

        if (this.uniqueProgramName) {
          if (!this.isNewOrg && this.organizationId) {
            this.$store.dispatch('createProgram', {
              organization: this.organizationId,
              title: this.title,
              title_otherText: this.title_otherText
            })
          } else if (this.isNewOrg) {
            this.newProgram = {
              title: this.title,
              title_otherText: this.title_otherText,
              isDefault: this.isDefault
            }
            this.didSubmitNewProgram = true
          }
        }
      },
      apiResponseMessage: function () {
        let message = ''
        if (this.isNewOrg && this.didSubmitNewProgram) {
          message = 'Success!'
          if (this.showModal) {
            this.$emit('updateNewProgram', this.newProgram)
            _.delay(this.reset, 1100)
            _.delay(this.clearForm, 1000)
            this.newProgram = null
            this.didSubmitNewProgram = null
            this.isDefault = null
          }
          return '<p>' + message + '</p>'
        }
        if (this.createProgramSuccess) {
          message = 'Success!'

          this.$store.dispatch('getOrganizationView', {
            id: this.organizationId
          })
        }

        if (this.createProgramFailure) {
          message = this.$utils.errorToHtml(this.createProgramFailure)
        }

        return '<p>' + message + '</p>'
      },
      clearForm () {
        this.$store.commit('RESET_CREATE_PROGRAM')
        this.organizationId = null
        this.title = null
      }
    },
    beforeDestroy () {
      this.reset()
    },
    created () {
      this.$store.dispatch('getProgramRecords', {})
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Admin/CreateProgramModal.vue